import React from 'react';
import { Link } from 'react-router-dom';
import IconEthereum from '../../../assets/images/icon-ethereum.png';
import { ENV } from '../../../config/config'

const ImagibleItem = (props) => {
	const { _id } = ENV.getUserKeys('_id')

	return (
		<div className="grid-item" data-groups={`["cat-${props.categoryId}"]`}>
			<div className="position-relative imagible-item overflow-hidden">
				<img className="img-fluid" src={props.image} alt="" />
				<div className="img-description text-center">
					<h2 className="mt-0">{props.name}</h2>
					<p>{props.description}</p>
					<div className="text-center mb-2">
						<Link className="btn btn-bordered-white" to={`/item-details?item=${window.btoa(props._id)}`}>{'View Details'}</Link>
					</div>
					<span className="price-detail d-flex justify-content-center align-items-center">
						<span className="price mx-1">{props.price}</span>
						<span className="currency-icon mx-1">
							<img className="img-fluid" src={IconEthereum} alt="" />
						</span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default ImagibleItem;